<template>
  <div class="aggregation-budget-page">
    <div class="search">
      <div class="left">
        <el-form
          :inline="true"
          class="query-form"
          @submit.native.prevent
        >
          <el-row
            :gutter="20"
            class="query-row"
          >
            <el-col
              :span="queryKeywordSpan"
              class="query-item"
            >
              <el-form-item>
                <el-input
                  v-model.trim="search.keyword"
                  placeholder="请输入编号/内容"
                  clearable
                  style="width: 100%"
                  @keyup.enter.native="handleSearch"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-show="queryFieldVisibility.dimension"
              :span="queryDimensionSpan"
              class="query-item"
            >
              <el-form-item>
                <el-select
                  v-model="search.dimension"
                  placeholder="选择维度"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(v, i) in optionDimensionList"
                    :key="i"
                    :label="v.name"
                    :value="v.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-show="queryFieldVisibility.status"
              :span="queryStatusSpan"
              class="query-item"
            >
              <el-form-item>
                <el-select
                  v-model="search.status"
                  placeholder="选择状态"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(v, i) in optionStatusList"
                    :key="i"
                    :label="v.name"
                    :value="v.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="queryActionSpan"
              class="query-item query-item--actions"
            >
              <div class="query-buttons">
                <el-button
                  plain
                  type="primary"
                  @click="handleReset"
                >
                  重置
                </el-button>
                <el-button
                  type="primary"
                  @click="handleSearch"
                >
                  查询
                </el-button>
                <!-- <el-button
                  v-if="showQueryToggle"
                  type="text"
                  class="query-toggle"
                  @click="toggleQueryExpand"
                >
                  {{ queryExpanded ? '收起' : '展开' }}
                  <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                </el-button> -->
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="data">
      <div class="table-header-actions">
        <el-button
          type="primary"
          plain
          :disabled="multipleSelection.length === 0"
          @click="handleBatchDialogOpen"
        >
          批量编辑
        </el-button>
        <el-button
          type="primary"
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div>
      <el-table
        ref="budgetTable"
        :data="list"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            <template v-if="c.prop === 'dimension'">{{ scope.row.dimension | filterDimension }}</template>
            <template v-else-if="c.prop === 'status'">
              <el-button
                v-if="scope.row.status === '0'"
                plain
                type="info"
                size="small"
              >
                失效
              </el-button>
              <el-button
                v-else
                type="success"
                size="small"
                plain
              >
                {{ scope.row.status | filterStatus }}
              </el-button>
            </template>
            <template v-else-if="c.prop === 'owner_name'">
              <span v-if="scope.row.owner_name_new">{{ scope.row.owner_name_new }}</span>
              <span v-else>-</span>
            </template>

            <template v-else-if="c.prop === 'content'">
              <div
                v-if="scope.row.content"
                style="display: flex;"
              >
                <span>{{ scope.row.content }}</span>
                <div v-if="scope.row.dimension === '1' && scope.row.agent_name">
                  <el-tooltip
                    effect="dark"
                    :content="scope.row.agent_name || ''"
                    placement="top"
                  >
                    <i class="el-icon-info" />
                  </el-tooltip>
                </div>
              </div>
              
              <span v-else>-</span>
            </template>

            <template v-else>
              {{ scope.row[c.prop] }}
            </template>

            <template v-if="c.prop === 'opt'">
              <el-button
                type="text"
                @click="handleCtrlEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlCancel(scope.row)"
              >
                {{ scope.row.status === '0' ? '置为有效' : '置为失效' }}
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlLogOpen(scope.row)"
              >
                日志
              </el-button>
            </template>
          </div>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div>
    </div>

    <!-- 新建 & 编辑 -->
    <el-dialog
      :visible.sync="detailVisible"
      :title="dialogTitle"
      width="600px"
      class="dialog"
      @close="handleDialogClose"
    >
      <el-form label-width="120px">
        <!-- <el-form-item label="聚合预算">
          <el-input
            v-model="form.budget_name"
            placeholder="输入聚合预算名称"
            class="input"
          />
        </el-form-item> -->
        <el-form-item
          label="聚合预算"
          prop="budget_name"
        >
          <el-select
            v-model="form.budget_name"
            filterable
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="输入并选择聚合预算"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 91%"
            @change="handleBudgetChange($event, form)"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.budget_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="销售名称">
          <span>{{ form.owner_name || '-' }}</span>
        </el-form-item>
        <el-form-item label="维度">
          <el-select
            v-model="form.dimension"
            placeholder="请选择维度"
            clearable
            style="width: 91%"
          >
            <el-option
              v-for="(item, i) in optionDimensionList"
              :key="i"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model="form.content"
            placeholder="输入对应维度匹配的内容"
            class="input"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button
          type="primary"
          @click="handleDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 批量编辑 -->
    <el-dialog
      :visible.sync="batchVisible"
      :title="batchDialogTitle"
      width="980px"
      class="dialog"
      @close="handleBatchDialogClose"
    >
      <div class="batch-dialog">
        <el-form label-width="120px">
          <el-form-item
            label="聚合预算修改为"
            prop="budget_name"
          >
            <el-select
              v-model="batchForm.budget_name"
              filterable
              clearable
              remote
              :remote-method="_searchSalors"
              placeholder="输入并选择聚合预算"
              :loading="editProdSalorDlg.searchLoading"
              style="width: 91%"
              @change="handleBudgetChange($event, batchForm)"
            >
              <el-option
                v-for="item in editProdSalorDlg.options"
                :key="item.id"
                :label="item.budget_name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>

        <div class="batch-dialog__section">
          <div class="batch-dialog__section-title">
            已选数据
            <span class="batch-dialog__count">{{ batchSelectedRows.length }}</span>
          </div>

          <el-table
            :data="batchSelectedRows"
            border
            size="mini"
            max-height="260"
          >
            <el-table-column
              label="编号"
              prop="id"
              width="100"
            />
            <el-table-column
              label="原聚合预算"
              prop="budget_name"
              min-width="180"
            />
            <el-table-column
              label="销售"
              min-width="150"
            >
              <template slot-scope="scope">
                {{ scope.row.owner_name_new || scope.row.owner_name || '-' }}
              </template>
            </el-table-column>
            <el-table-column
              label="维度"
              min-width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.dimension | filterDimension }}
              </template>
            </el-table-column>
            <el-table-column
              label="内容"
              prop="content"
              min-width="220"
            />
          </el-table>
        </div>
      </div>

      <span slot="footer">
        <el-button @click="handleBatchDialogClose">取消</el-button>
        <el-button
          type="primary"
          @click="handleBatchDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!--日志-->
    <el-dialog
      title="日志"
      :visible.sync="logVisible"
      width="800px"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { cloneDeep } from 'lodash';
const req = new Request();
let self;
const createDefaultSearch = () => ({
  keyword: '',
  dimension: '',
  status: '',
});
export default {
  name: 'aggregation-budget',

  filters: {
    filterDimension(v) {
      return self.optionDimensionList.filter((f) => f.value === Number(v))[0]
        .name;
    },
    filterStatus(v) {
      return self.optionStatusList.filter((f) => f.value === Number(v))[0].name;
    },
  },
  data() {
    return {
      optionDimensionList: [
        { name: '子代理名称', value: 1 },
        { name: '快应用公司名称', value: 2 },
        { name: '代理商公司名称', value: 3 },
      ],
      optionStatusList: [
        { name: '有效', value: 1 },
        { name: '失效', value: 0 },
      ],

      queryExpanded: true,
      search: createDefaultSearch(),

      column: [
        { label: '编号', prop: 'id' },
        { label: '聚合预算', prop: 'budget_name' },
        { label: '销售名称', prop: 'owner_name' },
        { label: '维度', prop: 'dimension' },
        { label: '内容', prop: 'content' },
        { label: '状态', prop: 'status' },
        { label: '操作', prop: 'opt' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,

      detailVisible: false,
      form: this.getEmptyForm(),
      batchVisible: false,
      batchForm: this.getBatchEmptyForm(),
      batchSelectedRows: [],
      multipleSelection: [],

      logVisible: false,
      logId: '',
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,

      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
    };
  },

  computed: {
    dialogTitle() {
      return this.form.id ? '编辑' : '添加';
    },

    batchDialogTitle() {
      return '批量编辑';
    },

    queryFieldVisibility() {
      return {
        dimension: true,
        status: true,
      };
    },
    showQueryToggle() {
      return true;
    },
    queryKeywordSpan() {
      return 6;
    },
    queryDimensionSpan() {
      return 6;
    },
    queryStatusSpan() {
      return 6;
    },
    queryActionSpan() {
      return 6;
    },
  },

  mounted() {
    self = this;
    this.init();
  },

  methods: {
    getEmptyForm() {
      return {
        id: '',
        budget_name: '',
        dimension: '',
        content: '',
        owner_name: '-',
        budget_id: '',
      };
    },
    getBatchEmptyForm() {
      return {
        id: '',
        budget_name: '',
        budget_id: '',
      };
    },

    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    // 输入并选择聚合预算下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.budgetBind.list, {
            keyword: key,
            page: this.page,
            page_size: 10000000000,
            status: 1,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.list || [];
      } catch (err) {
        this.$message.error(`获取聚合预算失败：${err.message || '未知错误'}`);
      }
    },
    // 聚合预算与销售名称实现联动
    handleBudgetChange(value, targetForm) {
      const selectedOption = this.editProdSalorDlg.options.find(
        (option) => option.id === value,
      );
      if (selectedOption) {
        const form = targetForm || this.form;
        form.budget_name = selectedOption.budget_name;
        form.owner_name =
          selectedOption.owner_name_new || selectedOption.owner_name;
        form.budget_id = parseInt(selectedOption.id, 10);
      }
    },
    init() {
      this.getList();
    },

    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },

    handleReset() {
      this.search = createDefaultSearch();
      this.page = 1;
      this.queryExpanded = false;
      this.getList();
    },

    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.budget.list, {
          keyword: this.search.keyword,
          dimension: this.search.dimension,
          status: this.search.status,
          page: this.page,
          page_size: this.pageSize,
        });
        this.list = data.list || [];
        this.total = Number(data.total);
        this.clearTableSelection();
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    clearTableSelection() {
      this.multipleSelection = [];
      this.$nextTick(() => {
        if (this.$refs.budgetTable && this.$refs.budgetTable.clearSelection) {
          this.$refs.budgetTable.clearSelection();
        }
      });
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },

    // 操作按钮: 编辑
    handleCtrlEdit(row) {
      this.form = {
        id: parseInt(row.id, 10),
        budget_name: row.budget_name,
        dimension: parseInt(row.dimension, 10),
        content: row.content,
        owner_name: row.owner_name_new || row.owner_name || '-',
        budget_id: parseInt(row.budget_id, 10),
      };
      this.detailVisible = true;
    },

    handleBatchDialogOpen() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先选择要批量编辑的数据');
        return;
      }

      this.batchSelectedRows = cloneDeep(this.multipleSelection);
      this.batchForm = this.getBatchEmptyForm();
      this.batchVisible = true;
    },

    // 操作按钮: 失效&有效
    handleCtrlCancel(row) {
      this.$confirm('确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await req.send(req.Apis.customer.budget.review, { id: row.id });
          this.$message.success('操作成功');
          this.getList();
        } catch (err) {}
      });
    },

    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budget.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 1,
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },

    // dialog: open
    handleDialogOpen() {
      this.detailVisible = true;
      this.form = this.getEmptyForm();
    },

    handleDialogClose() {
      this.detailVisible = false;
      this.form = this.getEmptyForm();
    },

    handleBatchDialogClose() {
      this.batchVisible = false;
      this.batchForm = this.getBatchEmptyForm();
      this.batchSelectedRows = [];
    },

    // dialog: 添加&编辑
    async handleDialogConfirm() {
      const params = {
        budget_name: this.form.budget_name,
        dimension: this.form.dimension,
        content: this.form.content,
        // owner_name: this.form.owner_name, // 添加销售名称到参数中
        budget_id: this.form.budget_id,
      };

      if (!this.form.budget_name) {
        this.$message.error('请输入聚合预算名');
        return;
      }
      if (!this.form.dimension) {
        this.$message.error('请选择维度');
        return;
      }
      if (!this.form.content) {
        this.$message.error('请输入对应维度匹配的内容');
        return;
      }

      try {
        if (this.form.id) {
          await req.send(req.Apis.customer.budget.update, {
            ...params,
            id: this.form.id,
          });
        } else {
          await req.send(req.Apis.customer.budget.add, params);
        }

        this.$message.success('操作成功');
        this.clearTableSelection();
        this.getList();
        this.handleDialogClose();
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    async handleBatchDialogConfirm() {
      const params = {
        budget_name: this.batchForm.budget_name,
        budget_id: this.batchForm.budget_id,
        ids: (this.batchSelectedRows || []).map(item => item.id).join(','),
      };

      if (!this.batchForm.budget_name) {
        this.$message.error('请输入聚合预算名');
        return;
      }
      if (!this.batchSelectedRows.length) {
        this.$message.warning('请先选择要批量编辑的数据');
        return;
      }

      try {
        await req.send(req.Apis.customer.budget.batchUpdate, {
          ...params,
        });

        this.$message.success('批量编辑成功');
        this.clearTableSelection();
        this.getList();
        this.handleBatchDialogClose();
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
  },
};
</script>

<style lang="less">
.aggregation-budget-page {
  .table-header-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 10px;
  }

  .search {
    display: flex;
    justify-content: space-between;
  }

  .left {
    flex: 1;
  }

  .query-form {
    width: 100%;
  }

  .query-item {
    margin-bottom: 12px;
  }

  .query-item--actions {
    display: flex;
    align-items: flex-start;
  }

  .query-buttons {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .query-toggle {
    padding: 0;
  }

  .data {
    margin-top: 20px;

    .page {
      margin-top: 20px;
      text-align: right;
    }
  }

  .dialog {
    .input {
      width: 400px;
    }
  }
}

.aggregation-budget-page .query-form .el-form-item {
  display: block;
  width: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

.aggregation-budget-page .query-form .el-form-item__content {
  width: 100%;
}

.aggregation-budget-page .query-buttons .el-button + .el-button {
  margin-left: 0;
}

.batch-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.batch-dialog__section {
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafafa;
}

.batch-dialog__section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #303133;
  font-size: 14px;
  font-weight: 700;
}

.batch-dialog__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  background: #f0f6ff;
  color: #409eff;
  font-size: 12px;
}
</style>
